import { useEffect, useState } from "react"
import {
  getServerUpdateInProgressSnapshot,
  subscribeServerUpdateInProgress,
  type ServerUpdateInProgressSnapshot,
} from "@core/utils/serverConnectionBootstrap"

export function useServerUpdateInProgress(): ServerUpdateInProgressSnapshot {
  const [snapshot, setSnapshot] = useState<ServerUpdateInProgressSnapshot>(() => getServerUpdateInProgressSnapshot())

  useEffect(() => {
    const syncSnapshot = () => {
      setSnapshot(getServerUpdateInProgressSnapshot())
    }

    const unsubscribe = subscribeServerUpdateInProgress(syncSnapshot)

    syncSnapshot()

    return () => {
      unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (!snapshot.inProgress || snapshot.expiresAt === null) {
      return
    }

    const remainingMs = snapshot.expiresAt - Date.now()

    if (remainingMs <= 0) {
      setSnapshot(getServerUpdateInProgressSnapshot())
      return
    }

    const timeoutId = window.setTimeout(() => {
      setSnapshot(getServerUpdateInProgressSnapshot())
    }, remainingMs + 100)

    return () => {
      window.clearTimeout(timeoutId)
    }
  }, [snapshot.expiresAt, snapshot.inProgress])

  return snapshot
}
